import { FC } from 'react';

import { FlowRadioGroup, getRadioGroupNameProps } from '@eneco/flows/components';
import { requiredRadioChoice } from '@eneco/flows/helpers';
import { RadioTile } from '@eneco/sparky';
import { usePlaceholderContent } from '@sitecore/common';
import { BuildingAgeStepRendering } from '@sitecore/types/BuildingAgeStep';
import * as yup from 'yup';

import { StepShell } from '../../components/StepShell/StepShell';
import { useFlowStep } from '../../hooks';
import { BuildingAgeType } from '../../types';

interface FormFields {
  buildingAge: BuildingAgeType;
}

export const BuildingAgeStep: FC = () => {
  const { BuildingAgeStep: { fields: textualData } = {} } = usePlaceholderContent<{
    BuildingAgeStep: BuildingAgeStepRendering;
  }>();

  const {
    form: {
      handleSubmit,
      control,
      formState: { errors, isSubmitSuccessful },
    },
  } = useFlowStep<FormFields>({
    buildSchema: () =>
      yup.object({
        buildingAge: requiredRadioChoice(textualData?.choice?.buildingAgeRadio?.value?.requiredMessage),
      }),
    defaultValues: context => ({ buildingAge: context.buildingAge }),
    onSubmitSuccess: formData => ({ ...formData }),
  });

  return (
    <StepShell
      handleSubmit={handleSubmit}
      textualData={textualData}
      isLoading={isSubmitSuccessful}
      nextButtonLabel={textualData?.content?.nextStepText?.value}>
      <FlowRadioGroup
        control={control}
        name="buildingAge"
        {...getRadioGroupNameProps(textualData?.choice?.buildingAgeRadio?.value?.label)}
        hint={textualData?.choice?.buildingAgeRadio?.value?.hint || undefined}
        direction="column"
        error={errors.buildingAge?.message}>
        {textualData?.choice?.buildingAgeRadio?.value?.options?.map(option => (
          <RadioTile key={option.label} value={option.name} subtitle={option.description || undefined}>
            {option.label}
          </RadioTile>
        ))}
      </FlowRadioGroup>
    </StepShell>
  );
};
